import { all, call } from 'redux-saga/effects';
import { authSaga } from './auth/auth.sagas';
import { sessionSaga } from './session/session.sagas';
import { dataSaga } from './data/data.sagas';

export default function* rootSaga(): Generator {
  yield all([call(authSaga), call(sessionSaga), call(dataSaga)]);
}
